// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__25YUq","checkmark":"Checkbox_checkmark__1hIIN"};